export default __webpack_public_path__ + "static/media/Fidelity Life Dark.2f31689e.svg";